var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHipcam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 29,
    viewBox: "0 0 144 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_5896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2012 1.80615V10.7628V11.8001V28.0182H30.9337V11.8001V10.7628V1.80615H28.2012Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3485 9.95311C57.3485 14.3808 53.8317 18.0748 48.9991 18.0748H41.8389V28.0435H39.0811V15.3929H49.0244C52.3642 15.3929 54.5148 12.8881 54.5148 9.95311C54.5148 6.99287 52.3895 4.51336 49.0244 4.51336H39.0811V1.83143H49.0244C53.9835 1.80613 57.3485 5.4748 57.3485 9.95311Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.758 28.0182H109.722L101.499 6.13266L93.251 28.0182H90.2148L100.234 1.80615H102.764L112.758 28.0182Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.271 1.57837V28.0181H140.513V8.94102L131.304 21.6928H131L121.487 8.94102V28.0181H118.754V1.57837H119.033L131.152 17.6193L142.942 1.57837H143.271Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7014 1.80615V13.5712H3.07726V1.80615H0.344727V16.1266V16.2784V28.0182H3.07726V16.2784H17.7014V28.0182H20.4339V14.1025V13.5712V1.80615H17.7014Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0521 20.4783C84.6485 25.3614 79.7654 27.9928 74.9075 27.9928C67.2159 27.9928 61.4473 21.9205 61.4473 14.4313C61.4473 6.94216 67.2412 1.02168 74.9075 0.920477C79.7654 0.844574 84.9268 4.13373 86.8497 8.18192H83.7124C81.8401 5.39879 78.6521 3.6024 74.9075 3.6024C68.734 3.6024 64.3316 8.46024 64.3316 14.4313C64.3316 20.4277 68.734 25.2855 74.9075 25.2855C78.6521 25.2855 82.1943 23.2108 84.0666 20.4277M74.8063 12.4325C75.9955 12.4325 76.9063 13.3434 76.9063 14.5325C76.9063 15.6711 75.9955 16.6325 74.8063 16.6325C73.6678 16.6325 72.7316 15.6711 72.7316 14.5325C72.7569 13.3434 73.6931 12.4325 74.8063 12.4325Z",
    fill: "#919191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_5896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.458,
    height: 27.8313,
    fill: "white",
    transform: "translate(0.0664062 0.566162)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHipcam);
export default __webpack_public_path__ + "static/media/logo-hipcam.8bdf23bcfbc7a2570468c52466c9324b.svg";
export { ForwardRef as ReactComponent };